import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

const bioTypeOptions = [
  'Candidate Bio',
  'Committee Staffer Bio',
  'Executive Bio',
  'Executive Staffer Bio',
  'Member Bio',
  'Member Staffer Bio',
  'Officer Bio',
  'Officer Staffer Bio',
  'Person Bio'
]

export const BioTypeSelect: React.FC<{ value: string | null, updateBioType: (bioType: string | null) => void, disabled: boolean }> = ({ value, updateBioType, disabled }) => {
  const handleChange = (value: string): void => {
    updateBioType(value)
  }

  return (
      <FormControl fullWidth variant="outlined">

      <InputLabel>Bio Type</InputLabel>
      <Select
        label="Bio Type"
        value={value ?? ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        {bioTypeOptions.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
